import axios from 'axios'

const api = axios.create({ baseURL: '/api' })

api.interceptors.request.use(config => {
  const token = localStorage.getItem('admin_token')
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

api.interceptors.response.use(res => {
  if (res.data.code === 401) {
    localStorage.removeItem('admin_token')
    localStorage.removeItem('admin_user')
    localStorage.removeItem('admin_perms')
    window.location.hash = '#/login'
  }
  return res
})

export default {
  getIconCatalog: type => api.get('/icon-catalog/'+encodeURIComponent(type)),
  batchUpdateIcons: (type,data) => api.post('/icon-catalog/'+encodeURIComponent(type)+'/batch',data),
  getIconCatalogMarkdown: () => api.get('/icon-catalog/export.md',{responseType:'blob'}),
  // 管理员登录
  login: (username, password) => api.post('/admin/login', { username, password }),
  suggestEntityId: (data) => api.post('/admin/entity-id/suggest', data),
  getGiftCodes: () => api.get('/admin/gift-codes'),
  getGiftCodeSettings: () => api.get('/admin/gift-codes/settings'),
  getGiftCodeRewardCatalog: () => api.get('/admin/gift-codes/reward-catalog'),
  updateGiftCodeSettings: data => api.put('/admin/gift-codes/settings', data),
  createGiftCode: data => api.post('/admin/gift-codes', data),
  updateGiftCode: (id,data) => api.put('/admin/gift-codes/'+id,data),
  getGiftCodeDetail: id => api.get('/admin/gift-codes/'+id),
  invalidateGiftCode: id => api.post('/admin/gift-codes/'+id+'/invalidate'),
  getGiftCodeRedemptions: id => api.get('/admin/gift-codes/'+id+'/redemptions'),
  adjustCurrency: (id,data) => api.post('/users/'+id+'/currency-adjust',data),
  getCurrencyLedger: (id,params) => api.get('/users/'+id+'/currency-ledger',{params}),
  updateCharacterProgression: (uid,cid,data) => api.put('/users/'+uid+'/characters/'+cid+'/progression',data),

  // 个人信息
  getProfile: () => api.get('/admin/profile'),
  changePassword: (oldPwd, newPwd) => api.put('/admin/password', { oldPassword: oldPwd, newPassword: newPwd }),

  // 管理员用户管理
  getAdminUsers: (params) => api.get('/admin/users', { params }),
  createAdminUser: (data) => api.post('/admin/users', data),
  updateAdminUser: (id, data) => api.put('/admin/users/' + id, data),
  deleteAdminUser: (id) => api.delete('/admin/users/' + id),

  // 角色管理
  getRoles: () => api.get('/admin/roles'),
  createRole: (data) => api.post('/admin/roles', data),
  updateRole: (id, data) => api.put('/admin/roles/' + id, data),
  deleteRole: (id) => api.delete('/admin/roles/' + id),
  getPermissions: () => api.get('/admin/permissions'),

  // 游戏数据（公开读取）
  getUsers: (params) => api.get('/users', { params }),
  getUser: (id) => api.get('/users/' + id),
  getUserRechargeOrders: (id) => api.get('/users/' + id + '/recharge-orders'),
  updateUser: (id, data) => api.put('/users/' + id, data),
  resetUserGameData: (id, confirmText) => api.post('/users/' + id + '/reset-game-data', { confirmText }),
  setUserVipTest: (id, overrideLevel) => api.post('/users/' + id + '/vip-test-setting', { overrideLevel }),
  resetUserVipTestWelfare: (id) => api.post('/users/' + id + '/vip-test-reset-welfare'),
  resetUserVipTestPacks: (id) => api.post('/users/' + id + '/vip-test-reset-packs'),
  updateUserItems: (id, items) => api.put('/users/' + id + '/items', { items }), // deprecated legacy bag only
  getWarehouseCatalog: (params) => api.get('/admin/warehouse-catalog', { params }),
  getUserWarehouse: (id) => api.get('/users/' + id + '/warehouse'),
  grantUserWarehouse: (id, data) => api.post('/users/' + id + '/warehouse/grant', data),
  revokeUserWarehouse: (id, data) => api.post('/users/' + id + '/warehouse/revoke', data),
  getUserCharacterLoadout: (uid, cid) => api.get('/users/' + uid + '/characters/' + cid + '/loadout'),
  getUserCharacterLoadouts: (uid) => api.get('/users/' + uid + '/character-loadouts'),
  getUserTankLoadout: (uid, tid) => api.get('/users/' + uid + '/tanks/' + tid + '/loadout'),
  getUserTankLoadouts: (uid) => api.get('/users/' + uid + '/tank-loadouts'),
  adminGrantAndEquipCharacter: (uid, cid, data) => api.post('/users/' + uid + '/characters/' + cid + '/equipment/grant-and-equip', data),
  adminGrantAndEquipTank: (uid, tid, data) => api.post('/users/' + uid + '/tanks/' + tid + '/equipment/grant-and-equip', data),
  adminEquipItem: (uid, data) => api.post('/users/' + uid + '/equipment/equip', data),
  adminUnequipItem: (uid, data) => api.post('/users/' + uid + '/equipment/unequip', data),
  adminMoveToCharacter: (uid, data) => api.post('/users/' + uid + '/warehouse/move-to-character', data),
  adminMoveToTank: (uid, data) => api.post('/users/' + uid + '/warehouse/move-to-tank', data),
  adminReturnItemToWarehouse: (uid, itemUid) => api.post('/users/' + uid + '/items/return-to-warehouse', { itemUid }),
  adminSwapCarrySlots: (uid, data) => api.post('/users/' + uid + '/items/swap-carry-slots', data),

  // 用户角色
  getUserCharacters: (uid) => api.get('/users/' + uid + '/characters'),
  addUserCharacter: (uid, data) => api.post('/users/' + uid + '/characters', data),
  updateUserCharacter: (uid, chId, data) => api.put('/users/' + uid + '/characters/' + chId, data),
  deleteUserCharacter: (uid, chId) => api.delete('/users/' + uid + '/characters/' + chId),

  // 用户坦克
  getUserTanks: (uid) => api.get('/users/' + uid + '/tanks'),
  addUserTank: (uid, data) => api.post('/users/' + uid + '/tanks', data),
  updateUserTank: (uid, tkId, data) => api.put('/users/' + uid + '/tanks/' + tkId, data),
  deleteUserTank: (uid, tkId) => api.delete('/users/' + uid + '/tanks/' + tkId),

  getChapters: () => api.get('/game/chapters', { params: { summary: 1 } }),
  getBattleConfig: () => api.get('/game/battle-config'),
  updateStageDifficultyMultiplier: value => api.put('/game/battle-config/stage-difficulty', { stage_difficulty_multiplier: value }),
  getShops: () => api.get('/game/shops'),
  getNodes: (chId, difficulty) => api.get('/game/chapters/' + chId + '/nodes', { params: { difficulty: difficulty || 'normal' } }),
  searchStages: params => api.get('/game/admin/stage-search', { params }),
  getRewardCatalog: () => api.get('/game/admin/reward-catalog'),
  getSigninConfig: () => api.get('/game/admin/signin-config'),
  saveSigninConfig: (monthKey, data) => api.put('/game/admin/signin-config/' + encodeURIComponent(monthKey), data),
  updateNode: (chId, nodeId, data) => api.put('/game/chapters/' + chId + '/nodes/' + nodeId, data),

  getBattleEffects: (params) => api.get('/game/battle-effects', { params }),
  createBattleEffect: data => api.post('/game/battle-effects', data),
  updateBattleEffect: (id,data) => api.put('/game/battle-effects/'+id,data),
  deleteBattleEffect: id => api.delete('/game/battle-effects/'+id),
  getBattleStatusEffects: params => api.get('/game/battle-status-effects', { params }),
  updateBattleStatusEffect: (key,data) => api.put('/game/battle-status-effects/'+encodeURIComponent(key),data),

  getItems: (params) => api.get('/game/items', { params }),
  createItem: (data) => api.post('/game/items', data),
  updateItem: (id, data) => api.put('/game/items/' + id, data),
  saveItem: (id, data) => api.put('/game/items/' + id, data),
  deleteItem: (id) => api.delete('/game/items/' + id),

  getWeapons: (params) => api.get('/game/weapons', { params }),
  createWeapon: (data) => api.post('/game/weapons', data),
  updateWeapon: (id, data) => api.put('/game/weapons/' + id, data),
  saveWeapon: (id, data) => api.put('/game/weapons/' + id, data),
  deleteWeapon: (id) => api.delete('/game/weapons/' + id),

  getArmors: (params) => api.get('/game/armors', { params }),
  createArmor: (data) => api.post('/game/armors', data),
  updateArmor: (id, data) => api.put('/game/armors/' + id, data),
  saveArmor: (id, data) => api.put('/game/armors/' + id, data),
  deleteArmor: (id) => api.delete('/game/armors/' + id),

  getEnemies: (params) => api.get('/game/enemies', { params }),
  getChapterEnemyOptions: () => api.get('/game/enemies/options'),
  createEnemy: (data) => api.post('/game/enemies', data),
  updateEnemy: (id, data) => api.put('/game/enemies/' + id, data),
  saveEnemy: (id, data) => api.put('/game/enemies/' + id, data),
  deleteEnemy: (id) => api.delete('/game/enemies/' + id),
  batchUpdateEnemyIdleImages: (data) => api.put('/game/enemies/batch-idle-images', data),
  batchUpdateEnemyRenderHeights: (data) => api.put('/game/enemies/batch-render-heights', data),

  // 章节管理
  createChapter: (data) => api.post('/game/chapters', data),
  updateChapter: (id, data) => api.put('/game/chapters/' + id, data),
  batchUpdateChapterAssets: (data) => api.put('/game/chapters/batch-assets', data),
  copyChapter: (id) => api.post('/game/chapters/' + id + '/copy'),
  sortChapters: (orders) => api.put('/game/chapters/sort', { orders }),

  // 素材管理
  getUploadToken: (params) => api.get('/upload/token', { params }),
  getUploadTokens: (data) => api.post('/upload/tokens', data),
  getMaterials: (params) => api.get('/materials', { params }),
  saveMaterial: (data) => api.post('/materials', data),
  batchSaveMaterials: (data) => api.post('/materials/batch', data),
  updateMaterial: (id, data) => api.put('/materials/' + id, data),
  deleteMaterial: (id) => api.delete('/materials/' + id),

  // 游戏角色
  getCharacters: (params) => api.get('/game/characters', { params }),
  getCharacter: (id) => api.get('/game/characters/' + id + '/template'),
  getCharacterGrowthProfiles: () => api.get('/game/characters/growth-profiles'),
  createCharacter: (data) => api.post('/game/characters', data),
  saveCharacter: (id, data) => api.put('/game/characters/' + id, data),
  patchCharacterActionImages: (id, data) => api.patch('/game/characters/' + id + '/action-images', data),
  deleteCharacter: (id) => api.delete('/game/characters/' + id),

  // 底盘/C装置/发动机
  getParts: (type, params) => api.get('/parts/' + type, { params }),
  createPart: (type, data) => api.post('/parts/' + type, data),
  updatePart: (type, id, data) => api.put('/parts/' + type + '/' + id, data),
  deletePart: (type, id) => api.delete('/parts/' + type + '/' + id),

  // 发射点
  getLaunchPoints: () => api.get('/game/launch-points'),
  saveLaunchPoint: (id, data) => api.put('/game/launch-points/' + id, data),

  // 文件上传
  uploadFile: (formData) => api.post('/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } }),

  // UI配置
  // 正式服数据分析
  getAnalyticsOverview: params => api.get('/admin/analytics/overview', { params }),
  getAnalyticsEconomy: params => api.get('/admin/analytics/economy', { params }),
  getAnalyticsGrowth: params => api.get('/admin/analytics/growth', { params }),
  getAnalyticsEngagement: params => api.get('/admin/analytics/engagement', { params }),
  getAnalyticsVideo: params => api.get('/admin/analytics/video', { params }),
  getAnalyticsStageLifecycle: params => api.get('/admin/analytics/stage-lifecycle', { params }),
  getAnalyticsOnline: params => api.get('/admin/analytics/online', { params }),
  getAnalyticsRisks: params => api.get('/admin/analytics/risks', { params }),
  searchAnalyticsPlayers: params => api.get('/admin/analytics/players/search', { params }),
  getAnalyticsPlayer: (userId, params) => api.get('/admin/analytics/players/' + userId, { params }),
  compareAnalyticsPlayers: data => api.post('/admin/analytics/players/compare', data),

  getUIConfigs: () => api.get('/admin/ui-configs'),
  updateUIConfig: (key, data) => api.put('/admin/ui-configs/' + key, data),
  getH5AccessConfig: () => api.get('/system/h5-access-config'),
  updateH5AccessConfig: data => api.put('/system/h5-access-config', data),
  getVipConfig: () => api.get('/admin/vip-config'),
  getPaymentOverview: (params) => api.get('/admin/payment-management/overview', { params }),
  getPaymentPlayers: (params) => api.get('/admin/payment-management/players', { params }),
  getPaymentOrders: (params) => api.get('/admin/payment-management/orders', { params }),
  getPaymentAccountProfile: (accountId) => api.get('/admin/payment-management/accounts/' + accountId),
  getPaymentOpsDashboard: () => api.get('/admin/payment-management/operations/dashboard'),
  getPaymentGate: () => api.get('/admin/payment-management/operations/gate'),
  setPaymentGate: (data) => api.put('/admin/payment-management/operations/gate', data),
  getPaymentAnomalies: () => api.get('/admin/payment-management/operations/anomalies'),
  searchPaymentOpsPlayers: (q) => api.get('/admin/payment-management/operations/players', { params: { q } }),
  reconcilePaymentOrder: (outTradeNo, data) => api.post('/admin/payment-management/orders/' + encodeURIComponent(outTradeNo) + '/reconcile', data || {}),
  getPaymentRefunds: (params) => api.get('/admin/payment-management/refunds', { params }),
  createPaymentRefund: (data) => api.post('/admin/payment-management/refunds', data),
  syncPaymentRefund: (id, data) => api.post('/admin/payment-management/refunds/' + encodeURIComponent(id) + '/sync', data || {}),
  createManualRecharge: (data) => api.post('/admin/payment-management/manual-recharges', data),
  compensatePaymentBlue: (data) => api.post('/admin/payment-management/compensations/blue', data),
  getPaymentOperationLogs: (params) => api.get('/admin/payment-management/operation-logs', { params }),
  searchMailPlayers: (q) => api.get('/admin/mail-management/players', { params: { q } }),
  getMailRecords: (params) => api.get('/admin/mail-management/mails', { params }),
  getMailRecipients: (id, params) => api.get('/admin/mail-management/mails/' + encodeURIComponent(id) + '/recipients', { params }),
  sendMail: (data) => api.post('/admin/mail-management/send', data),
  updateVipFashion: (id, data) => api.put('/admin/vip-fashions/' + encodeURIComponent(id), data),
  updateVipFashionVariant: (id, gender, data) => api.put('/admin/vip-fashions/' + encodeURIComponent(id) + '/variants/' + encodeURIComponent(gender), data),
  patchVipFashionActionImages: (id, gender, data) => api.patch('/admin/vip-fashions/' + encodeURIComponent(id) + '/variants/' + encodeURIComponent(gender) + '/action-images', data),
  updateVipFashionAsset: (id, characterId, data) => api.put('/admin/vip-fashions/' + encodeURIComponent(id) + '/assets/' + encodeURIComponent(characterId), data),

  // 竞技场运营配置
  getArenaConfig: () => api.get('/system/arena-config'),
  updateArenaConfig: data => api.put('/system/arena-config', data),

  // 坦克管理
  getTanks: (params) => api.get('/tanks', { params }),
  getTank: (id) => api.get('/tanks/' + id),
  createTank: (data) => api.post('/tanks', data),
  updateTank: (id, data) => api.put('/tanks/' + id, data),
  deleteTank: (id) => api.delete('/tanks/' + id),

  // 活动中心 / 世界BOSS
  getWorldBossConfig: () => api.get('/activities/admin/world-boss/config'),
  saveWorldBossConfig: data => api.put('/activities/admin/world-boss/config', data),
  getWorldBossEnemies: () => api.get('/activities/admin/world-boss/enemies'),
  getWorldBossSessions: () => api.get('/activities/admin/world-boss/sessions'),
  getBountySpeedrunConfig: () => api.get('/activities/admin/bounty-speedrun'),
  getPeakTowerConfig: () => api.get('/activities/admin/peak-tower'),
  savePeakTowerRewards: data => api.put('/activities/admin/peak-tower/rewards', data),
  compensatePeakTowerReward: data => api.post('/activities/admin/peak-tower/compensate', data),
  searchPeakTowerTestUsers: q => api.get('/activities/admin/peak-tower/test-users/search', { params:{ q } }),
  savePeakTowerTestUsers: data => api.put('/activities/admin/peak-tower/test-users', data),
  getWeeklyEvents: () => api.get('/activities/admin/weekly'),
  getWeeklyRewardCatalog: () => api.get('/activities/admin/weekly/reward-catalog'),
  getWeeklyEvent: code => api.get('/activities/admin/weekly/' + encodeURIComponent(code)),
  saveWeeklyEvent: (code, data) => api.put('/activities/admin/weekly/' + encodeURIComponent(code), data),
  publishWeeklyPreview: (code, data) => api.post('/activities/admin/weekly/' + encodeURIComponent(code) + '/publish-preview', data),
  cloneWeeklyEvent: (code, newEventCode) => api.post('/activities/admin/weekly/' + encodeURIComponent(code) + '/clone', { newEventCode }),
  getTankSkinsAdmin: () => api.get('/admin/cosmetics/tank-skins'),
  saveTankSkinAdmin: (id, data) => api.put('/admin/cosmetics/tank-skins/' + encodeURIComponent(id), data),
  getAvatarFramesAdmin: () => api.get('/admin/cosmetics/avatar-frames'),
  saveAvatarFrameAdmin: (id, data) => api.put('/admin/cosmetics/avatar-frames/' + encodeURIComponent(id), data),
  getLongTermActivities: () => api.get('/activities/admin/long-term'),
  getLongTermActivity: code => api.get('/activities/admin/long-term/' + encodeURIComponent(code)),
  saveLongTermActivity: (code, data) => api.put('/activities/admin/long-term/' + encodeURIComponent(code), data),
  getDreamEnemies: () => api.get('/activities/admin/wasteland/enemies'),
  getDreamConfig: () => api.get('/activities/admin/wasteland/config'),
  saveDreamConfig: data => api.put('/activities/admin/wasteland/config',data),
  resetDream: data => api.post('/activities/admin/wasteland/reset',data),
  getDreamRewardCatalog: () => api.get('/activities/admin/wasteland/reward-catalog'),
  getDreamShop: () => api.get('/activities/admin/wasteland/shop'),
  saveDreamShop: products => api.put('/activities/admin/wasteland/shop',{products}),
  saveDreamProject: (id,data) => api.put('/activities/admin/wasteland/maps/'+encodeURIComponent(id)+'/project',data,{timeout:30000}),
  getDreamSprites: () => api.get('/activities/admin/wasteland/sprites'),
  getDreamSprite: (type,id) => api.get('/activities/admin/wasteland/sprites/'+encodeURIComponent(type)+'/'+encodeURIComponent(id)),
  saveDreamSprite: data => api.put('/activities/admin/wasteland/sprites',data),
  getWastelandSchemaPreflight: force => api.get('/activities/admin/wasteland/schema-preflight', { params: force ? { force: 1 } : {} }),
  getWastelandGlobal: () => api.get('/activities/admin/wasteland/global'),
  saveWastelandGlobal: data => api.put('/activities/admin/wasteland/global', data),
  getWastelandPools: () => api.get('/activities/admin/wasteland/pools'),
  saveWastelandPools: data => api.put('/activities/admin/wasteland/pools', data),
  getDreamRomImportPreview: () => api.get('/activities/admin/wasteland/rom-import'),
  importDreamRomDrafts: data => api.post('/activities/admin/wasteland/rom-import',data,{timeout:120000}),
  getDreamPlayablePreview: () => api.get('/activities/admin/wasteland/rom-playable-world'),
  deployDreamPlayable: data => api.post('/activities/admin/wasteland/rom-playable-world',data,{timeout:180000}),
  upgradeDreamRomDrafts: data => api.post('/activities/admin/wasteland/rom-upgrade',data,{timeout:120000}),
  getWastelandMaps: () => api.get('/activities/admin/wasteland/maps'),
  getWastelandMap: id => api.get('/activities/admin/wasteland/maps/' + encodeURIComponent(id)),
  getDreamRomShopPage: (type,page) => api.get('/activities/admin/wasteland/rom-shop/'+encodeURIComponent(type)+'/'+encodeURIComponent(page)),
  getDreamRomArchive: code => api.get('/activities/admin/wasteland/rom-archive/' + encodeURIComponent(code)),
  getDreamRomScript: (kind,id) => api.get('/activities/admin/wasteland/rom-archive-script/' + encodeURIComponent(kind) + '/' + encodeURIComponent(id)),
  createWastelandMap: data => api.post('/activities/admin/wasteland/maps', data),
  saveWastelandMap: (id, data) => api.put('/activities/admin/wasteland/maps/' + encodeURIComponent(id), data),
  saveWastelandLayout: (id, data) => api.put('/activities/admin/wasteland/maps/' + encodeURIComponent(id) + '/layout', data, { timeout: 30000 }),
  getWastelandPublishStatus: (id, requestId) => api.get('/activities/admin/wasteland/maps/' + encodeURIComponent(id) + '/publish-status', { params: { requestId: requestId } }),
  getSteelKingConfig: () => api.get('/activities/admin/steel-king'),
  saveSteelKingConfig: data => api.put('/activities/admin/steel-king', data),

  // V118 装备进化配置
  getEquipmentEvolution: section => api.get('/game/admin/equipment-evolution/' + section),
  createEquipmentEvolution: (section, data) => api.post('/game/admin/equipment-evolution/' + section, data),
  updateEquipmentEvolution: (section, id, data) => api.put('/game/admin/equipment-evolution/' + section + '/' + encodeURIComponent(id), data),
  deleteEquipmentEvolution: (section, id) => api.delete('/game/admin/equipment-evolution/' + section + '/' + encodeURIComponent(id)),
  getGiftBoxes: () => api.get('/game/admin/gift-boxes'),
  saveGiftBox: (id,data) => api.put('/game/admin/gift-boxes/' + encodeURIComponent(id), data),
  getAdvancedShopSettings: () => api.get('/game/admin/equipment-evolution/advanced-shop/settings'),
  updateAdvancedShopSettings: data => api.put('/game/admin/equipment-evolution/advanced-shop/settings', data)
}
